/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '@/services/toast';
import countries from '@/services/country.json'
import carousel from 'vue-owl-carousel';
import activityTrackerUserList from '../activity-tracker-user-list/index.vue';
import myCoreTeam from '../my-core-team-list/index.vue';
import coreSentRequest from '../core-team-sent-request/index.vue';
import coreTeammateGroups from '../core-teammate-groups/index.vue';
import {
  bus
} from '@/main';
export default {
  name: 'team-users-list',
  components: {
    carousel,
    'activity-tracker-list' : activityTrackerUserList,
    'my-core-team-list' : myCoreTeam,
    'core-sent-request-list' : coreSentRequest,
    'core-teammate-groups' : coreTeammateGroups
  },
  props: [],
  data () {
    return {
      employeeList:null,
      employeeListResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
      nextPageUrl:null,
      search_term:'',
      searchUserListState:true,
      searchUsersList:[],
      searchUsersData:null,
      requestMemberPopupState:false,
      requestMemberinfo:{},
      userProfileDetails:null,
      pro_payment:false,
      auto_payment:false,
      regular_payment:false,
      filterTabsChangedState:'core_members',
      userFilterInfoData:'',
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false
    }
  },
  computed: {
  ...mapGetters([
    'getUserListOfTeamHeadGetters',
    'acUserDetailsStateGetters',
  ]),
  getEmployeeListFun(){
   this.employeeList = this.$store.getters.getUserListOfTeamHeadGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.employeeList != undefined) {
      this.nextStep = this.employeeList.next
      this.nextPageUrl = this.employeeList.next
      this.employeeListResults = this.employeeList.results
    }
  },
  getUserDetailsInfo(){
    this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
    return
  },
  getUserDetailsIntialState(){
    if(this.userProfileDetails){
      this.pro_payment = this.userProfileDetails.pro_payment
      this.auto_payment = this.userProfileDetails.auto_payment
      this.regular_payment = this.userProfileDetails.regular_payment
    }
  },
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getEmployeeListFun
    this.SetIntialStatus 
    this.getUserDetailsInfo
    this.getUserDetailsIntialState
    bus.$on('requestMemberPopupStateBus', (data) => {
      this.requestMemberPopupState = data
      if(data == false){
        this.search_term = ''
        this.searchUserListState = true
      }
    })
  },
  methods: {
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    filterTabsChangesMethod(arg){
      this.filterTabsChangedState = arg
      $('.total_count_box').removeClass('active')
      $('#filtered' + arg).addClass('active')
    },
    requestMemberPopupMethod(Data){
      this.requestMemberPopupState = true
      this.requestMemberinfo = Data
      $('body').addClass('body_right_scroll_remove')
    },
    validateSearchModelsBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 5){
            this.$store.dispatch('searchUserForTeamHeadFun', { search_term: this.search_term }).then((response) => {
              this.searchUserListState = false
              this.searchUsersData = response.data
              this.searchUsersList = this.searchUsersData.data
            })
          }else{
            this.searchUserListState = true
            this.searchUsersData = null
            this.searchUsersList = []
          }
        }
      })
    },
    getRemoveListAgain() {
      this.$store.dispatch('getUserListOfTeamHeadFun').then((res) => {
        this.employeeList = res.data.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("notConnectedUserBody");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeUserForTeamToTeamHeadFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("notConnectedUserBody");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("notConnectedUserBody");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.employeeListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.employeeListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    }
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    getEmployeeListFun(){
      return  this.$store.getters.getUserListOfTeamHeadGetters
    },
    SetIntialStatus() {
      if (this.employeeList != undefined) {
        this.employeeListResults = this.employeeList.results
      }
    },
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getUserDetailsIntialState(){
      if(this.userProfileDetails){
        this.pro_payment = this.userProfileDetails.pro_payment
        this.auto_payment = this.userProfileDetails.auto_payment
        this.regular_payment = this.userProfileDetails.regular_payment
      }
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("notConnectedUserBody");
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}